var React = require('react');

function Disabled (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"6","cy":"6","r":"6","fill":"#333","key":0}),React.createElement("path",{"d":"M6 3a.75.75 0 01.75.75v3a.75.75 0 11-1.5 0v-3A.75.75 0 016 3zm0 5.25a.75.75 0 010 1.5.75.75 0 010-1.5z","fill":"#FFF","key":1})]));
}

Disabled.defaultProps = {"width":"12","height":"12"};

module.exports = Disabled;

Disabled.default = Disabled;
